import { Toaster } from "react-hot-toast";

const StyledToaster = () => {
    return (
        <Toaster
            position="top-right"
            toastOptions={{
                style: {
                    borderRadius: "8px",
                    borderLeft: "4px solid #2797E8",
                    padding: "12px",
                    background: "#ffffff",
                    color: "#3D4C66",
                    minWidth: "150px",
                    minHeight: "100px",
                    fontFamily: "Poppins"
                },
                success: {
                    duration: 2000,
                    style: {
                        borderLeft: "6px solid #47D2A5"
                    },
                    icon: <div style={{ flexShrink: 0 }}>{/* <Icon type={IconType.Final} width={25} height={25} /> */}</div>
                },
                error: {
                    duration: 2000,
                    style: {
                        borderLeft: "6px solid #FF525F"
                    },
                    icon: <div style={{ flexShrink: 0 }}>{/* <Icon type={IconType.Final} width={25} height={25} /> */}</div>
                }
            }}
        />
    );
};

export default StyledToaster;
